export const CalendarTimeFormatMixin = {
  computed: {
    calendarTimeFormat() {
      const facility = this.$store.state.facilityModule.selectedFacility;

      return facility?.timeFormat === "hh:mm A" ? "LT" : facility?.timeFormat;
    }
  }
}